import api from './api'

export const therapyTeamService = {
  fetchList() {
    return api.get('/therapy/teams')
  },
  create(payload) {
    return api.post('/therapy/teams', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/teams/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/teams/${id}/status`, null, { params: { status } })
  }
}
